var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entry-view d-flex align-items-center justify-content-center min-vh-100"},[_c('p',{staticClass:"text-muted"},[_vm._v("Memuat...")])])
}]

export { render, staticRenderFns }